export default __webpack_public_path__ + "static/media/Servicing&MOT.6d9fc32b.svg";